import React, { useState, useEffect, FC } from 'react';
import _find from 'lodash/find';
import ControlledRadioGroup from '@minecraft.controlled-radio-group';

type Option = {
  name?: string;
  label?: string;
  value: string;
  count?: number;
  disabled?: boolean;
  labelComponent?: () => React.ReactNode;
  subText?: string;
};

type Props = {
  saveAsOption?: boolean;
  enableReinitializeDefaultValue?: boolean;
  options: Array<Option>;
  onChange: (e: React.FormEvent<HTMLInputElement>, option: string | Option) => void;
  defaultValue?: any;
  name: string;
  className?: string;
  hideCount?: boolean;
  radioGroupLabel: string;
};

/**
 * @deprecated This is an older component that does not use our standard form wrapper
 * to match the design system.
 *
 * If this component is used in application code, we want to replace it with a controlled
 * RadioGroupInput component instead
 *
 * use the RadioGroupInput
 * import { RadioGroupInput } from '@minecraft.molecules'
 *
 * <RadioGroupInput name="fieldName" label="Field Label" options={options} />
 *
 * for any props that are not currently implemented we should add the functionality
 */
const UncontrolledRadioGroup: FC<Props> = ({
  saveAsOption = false,
  enableReinitializeDefaultValue = false,
  defaultValue,
  options,
  onChange,
  className,
  hideCount,
  name,
  ...restProps
}) => {
  const [selectedValue, setSelectedValue] = useState(defaultValue);

  useEffect(() => {
    if (enableReinitializeDefaultValue) {
      setSelectedValue(defaultValue);
    }
  }, [defaultValue]);

  return (
    <ControlledRadioGroup
      hideCount={hideCount}
      options={options}
      name={name}
      value={selectedValue}
      onChange={(e, value): void => {
        const newValue = saveAsOption ? _find(options, (option) => option.value === value) : value;

        setSelectedValue(newValue);
        onChange(e, newValue);
      }}
      className={className}
      {...restProps}
    />
  );
};

export default UncontrolledRadioGroup;
